import React, { useContext, useEffect, useRef, useState } from "react";

import { useNavigate } from "react-router-dom";

import Swal from "sweetalert2";
import OTPInput from "react-otp-input";
import "../../../styles/Login.css";
import Logo from "../../../assets/icons/logo.svg";

import {
  decryption,
  encryption,
  setToLocalStorage,
} from "../../../utils/common-utils";
import { VerifyOtpAuth } from "../../../api/Api";
import Back from "../../../assets/images/back.svg";
import { AppContext } from "../../../context/AppContext";
import IhpLogo from "../../../assets/images/ihp_logo.jpeg";

const OtpVerification = () => {
  const INITIAL_COUNT = 120;
  const STATUS = {
    STARTED: "Started",
  };
  const navigate = useNavigate();
  const { setContextStates } = useContext(AppContext);
  const [inputOtp, setInputOtp] = useState("");
  const [error, setError] = useState(false);
  const [status, setStatus] = useState(STATUS.STOPPED);
  const [confirmLoader, setConfirmLoader] = useState(false);
  const [secondsRemaining, setSecondsRemaining] = useState(INITIAL_COUNT);

  const handleSubmit = async () => {
    if (!inputOtp || inputOtp?.length < 6) {
      setError(true);
    } else {
      setError(false);
      setConfirmLoader(true);
      let payload = {
        googleAuthOtp: inputOtp,
      };
      let encryptedPayload = encryption(JSON.stringify(payload));
      const response = await VerifyOtpAuth(encryptedPayload);
      setConfirmLoader(false);
      console.log("responsevefrify", response);
      if (response?.data) {
        let decryptedResponse = JSON.parse(decryption(response?.data));
        console.log("decryptedResponsepin", decryptedResponse);
        if (decryptedResponse?.statusDescription?.statusCode === 200) {
          localStorage.setItem(
            "token",
            decryptedResponse?.usermodel?.userTokenDetails?.jwtToken
          );
          setToLocalStorage("userData", decryptedResponse?.usermodel);
          setToLocalStorage(
            "sideMenus",
            decryptedResponse?.usermodel?.role?.roleMenu
          );
          setContextStates((prev) => {
            return {
              ...prev,
              actualToken: decryptedResponse?.jwtToken,
              profileTab: 0,
            };
          });
          navigate("/");
          Swal.fire({
            icon: "success",
            text: decryptedResponse?.statusDescription?.description,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: decryptedResponse?.statusDescription?.description,
          });
          setInputOtp("");
        }
      }
    }
  };

  const handleStart = () => {
    setStatus(STATUS.STARTED);
    setSecondsRemaining(INITIAL_COUNT);
  };

  useInterval(
    () => {
      if (secondsRemaining > 0) {
        setSecondsRemaining(secondsRemaining - 1);
      } else {
        setStatus(STATUS.STOPPED);
      }
    },
    status === STATUS.STARTED ? 1000 : null
  );

  function useInterval(callback, delay) {
    const savedCallback = useRef();

    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  }

  useEffect(() => {
    handleStart();
    const verifyotp = JSON.parse(
      localStorage.getItem("loginDetails")
    )?.twoFactorAuthenticationModel;
    let otp;
    for (let index = 0; index < verifyotp?.length; index++) {
      const element = verifyotp[index];
      if (element?.isActive == true) {
        otp = element?.twoFaAuthenticationType;
        break;
      }
    }
  }, []);

  return (
    <section id="login">
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="wrapper" id="otp-box">
              <div className="box w-100 m-auto">
                <div className="logo m-auto">
                  <img src={Logo} title="logo" className="d-block m-auto" />
                </div>
                <p className="fontNormal text-center text-white mt-3 mb-2">
                  You are one step away from accessing the portal
                </p>
                <p className="fontNormal text-center text-white">
                  OTP send to your mobile number XXXXXX1234
                </p>
                <p className="fontNormal text-center text-white">
                  Please enter the OTP to verify
                </p>
                <div class="mt-4 text-center d-flex align-items-center justify-content-center">
                  <OTPInput
                    value={inputOtp}
                    onChange={setInputOtp}
                    inputType="number"
                    numInputs={6}
                    renderSeparator={<span>-</span>}
                    renderInput={(props, index) => (
                      <input
                        {...props}
                        style={{ color: 'white' }}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            handleSubmit();
                          }
                        }}
                        shouldAutoFocus={true}
                        autoFocus={index === 0}
                      />
                    )}
                  />
                  <p className="text-danger mt-2" style={{ fontSize: "14px" }}>
                    {error && (!inputOtp || inputOtp?.length < 6) && (
                      <>
                        {!inputOtp
                          ? "Please enter the OTP"
                          : inputOtp?.length < 6
                          ? "Invalid OTP"
                          : ""}
                      </>
                    )}
                  </p>
                </div>
                <a
                  href="#"
                  className="fontNormal text-decoration-none d-block me-0 ms-auto text-end me-2 pe-1 mt-3"
                >
                  Resend OTP
                </a>
                <div className="buttons d-flex align-items-center justify-content-center mt-4">
                  <button
                    className="login back text-white fw-bold me-3"
                    onClick={() => navigate("/")}
                  >
                    Back
                  </button>
                  <button className="login text-white fw-bold" onClick={() => handleSubmit()}>Verify</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    // old

    // <Box>
    //   <div id="otp">
    //     <div className="logo w-100 text-center d-block m-auto">
    //       <img src={IhpLogo} alt="logo" className="mb-2 w-100 m-auto d-block" />
    //     </div>
    //     <span
    //       type="button"
    //       className="w-25"
    //       variant="contained"
    //       sx={{ mt: 3, mb: 2, bgcolor: "grey" }}
    //       color="secondary"
    //       onClick={() => navigate("/")}
    //     >
    //       <img src={Back} alt="back" className="mb-2" />
    //     </span>
    //     <Typography component="h3" className="fw-bold text-start">
    //       2 Factor Authentication
    //     </Typography>
    //     <div>
    //       <p className="mt-2 mb-3">
    //         Enter 6 digit OTP code displayed in your google authenticator app
    //       </p>
    //     </div>

    //     <Box component="form" style={{ height: "100%" }}>
    //       <OTPInput
    //         value={inputOtp}
    //         onChange={setInputOtp}
    //         inputType="number"
    //         numInputs={6}
    //         renderSeparator={<span>-</span>}
    //         renderInput={(props, index) => (
    //           <input
    //             {...props}
    //             onKeyPress={(e) => {
    //               if (e.key === "Enter") {
    //                 handleSubmit();
    //               }
    //             }}
    //             shouldAutoFocus={true}
    //             autoFocus={index === 0}
    //           />
    //         )}
    //       />
    //       <p className="text-danger mt-2" style={{ fontSize: "14px" }}>
    //         {error && (!inputOtp || inputOtp?.length < 6) && (
    //           <>
    //             {!inputOtp
    //               ? "Please enter the OTP"
    //               : inputOtp?.length < 6
    //                 ? "Invalid OTP"
    //                 : ""}
    //           </>
    //         )}
    //       </p>
    //       <div className="d-flex justify-content-center buttons">
    //         <LoadingButton
    //           type="button"
    //           className="w-100"
    //           variant="contained"
    //           sx={{ mt: 3, mb: 2, bgcolor: "#009900" }}
    //           color="primary"
    //           fullWidth
    //           loading={confirmLoader}
    //           loadingPosition="end"
    //           onClick={() => handleSubmit()}
    //         >
    //           Verify and continue
    //         </LoadingButton>
    //       </div>
    //     </Box>
    //   </div>
    // </Box>

    // old
  );
};

export default OtpVerification;
